import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AngularFireAuth} from 'angularfire2/auth';
import {SweetAlertService} from 'ngx-sweetalert2';
import {AngularFirestore} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {NotificationModel} from './notification.model';
import {HttpClient} from '@angular/common/http';
import {UserService} from '../../pages/user.service';
import {UserModel} from '../../pages/user.model';
import {NavigationService} from './navigation.service';
import {Subscription} from 'rxjs/Subscription';

@Component({
  selector: 'ap-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit, OnDestroy {

  name: string;
  showHide: boolean;
  userName = '';
 /* user: UserModel;*/
  notification: NotificationModel;

  notificationObservable: Observable<NotificationModel>;

  navigationDataSubscription: Subscription;

  @Input('user') user: UserModel;

  constructor(private router: Router, private afAuth: AngularFireAuth, private firestore: AngularFirestore, private alertService: SweetAlertService,
              private http: HttpClient, private userService: UserService, private naviService: NavigationService) {
    this.showHide = true;

    this.notificationObservable = this.firestore.doc<NotificationModel>('company/pnc').valueChanges();

    /*this.userService.currentUser.subscribe(user => {
      this.user = user;
    });*/

    this.notification = new NotificationModel();
  }

  changeShowStatus() {
    this.showHide = !this.showHide;
  }


  ngAfterViewInit() {

    this.navigationDataSubscription = this.naviService.getNavigationData().subscribe(data => {
      this.notification.RcvCnt = data.RcvCnt;
      this.notification.ShpCnt = data.ShpCnt;
      this.notification.LentDelayCnt = data.LentDelayCnt;
      this.notification.CollLackCnt = data.CollLackCnt;
    }, error => console.error('내비게이션 데이터 폴링 에러', error));

    $(function () {
      $('.preloader').fadeOut();
    });

    const set = function () {
      const width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
      const topOffset = 0;
      if (width < 1170) {
        $('body').addClass('mini-sidebar');
        $('.navbar-brand span').hide();
        $('.sidebartoggler i').addClass('ti-menu');
      } else {
        $('body').removeClass('mini-sidebar');
        $('.navbar-brand span').show();
      }

      let height = ((window.innerHeight > 0) ? window.innerHeight : this.screen.height) - 1;
      height = height - topOffset;
      if (height < 1) { height = 1; }
      if (height > topOffset) {
        $('.page-wrapper').css('min-height', (height) + 'px');
      }

    };
    $(window).ready(set);
    $(window).on('resize', set);

    $(document).on('click', '.mega-dropdown', function (e) {
      e.stopPropagation();
    });

    $('.search-box a, .search-box .app-search .srh-btn').on('click', function () {
      $('.app-search').toggle(200);
    });

    (<any>$('.scroll-sidebar, .right-sidebar, .message-center')).perfectScrollbar();

    $('body').trigger('resize');
  }

  ngOnDestroy(): void {
    this.navigationDataSubscription.unsubscribe();
  }

  logout() {
    console.log('logOut');

    this.afAuth.auth.signOut()
      .then(a => {
        this.router.navigate(['login']);
      })
      .catch(error => {
        console.error(error);
        this.alertService.error({title: '로그아웃 에러'});
      });
  }

}



// WEBPACK FOOTER //
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/app/shared/header-navigation/navigation.component.ts